
        // Replace the locations with the actual latitude and longitude of your desired locations
        var locations = [
            { lat: 32.9620841, lng: -117.1924174, name: 'Carmel Valley, SD', address: '5980 Village Way Suite B104', city: 'San Diego', state: 'CA', zip: '92130'},
            { lat: 34.0369585, lng: -118.4459274, name: 'West LA', address: '5980 Village Way Suite B10', city: 'Los Angeles', state: 'CA', zip: '90064' },
            { lat: 33.0359436, lng: -117.2876837, name: 'Encinitas', address: '485 Santa Fe Dr', city: 'Encinitas', state: 'CA', zip: '92024' },
            // Add more locations as needed
        ];

        function initMap() {
            var mapOptions = {
                center: { lat: 37.0902, lng: -95.7129 }, // Choose the center of the map
                zoom: 4 // Choose the initial zoom level,

            };
            var mapContainers = document.getElementsByClassName('google-map');
            if (mapContainers.length > 0) {

            // Loop through all matching elements and initialize a map on each one
            for (var i = 0; i < mapContainers.length; i++) {
              var map = new google.maps.Map(mapContainers[i], mapOptions);
              var bounds = new google.maps.LatLngBounds();

            // Create markers for each location
            locations.forEach(function (location) {
                var marker = new google.maps.Marker({
                    position: { lat: location.lat, lng: location.lng },
                    map: map,
                    title: location.name
                });

                bounds.extend(marker.getPosition());

                 var contentString = `
                    <div class="marker-info">
                        <h4>${location.name}</h4>
                        <p>${location.address}</p>
                        <p>${location.city}, ${location.state}</p>
                    </div>
                `;

                // Add info window for each marker
                var infoWindow = new google.maps.InfoWindow({
                     content: contentString
                });

                marker.addListener('click', function () {
                    infoWindow.open(map, marker);
                });

            });
            // Automatically fit the map to all the markers
            map.fitBounds(bounds);
        }
    }

    }

document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/g, "") + "js"

if (window.location.hash) { setTimeout(function () { window.scrollTo(0, 0); }, 2); }

jQuery(document).ready(function ($) {



/* ========================================================================================================================

Announcement    

======================================================================================================================== */
  var announcement = (function(){
    $('.gheader').on('click', '.close-announcement', function () {
        $(this).parent().parent().hide();
    });

}());


/* ========================================================================================================================

Header Search  

======================================================================================================================== */
 var SearchMenu = (function() {
        var $searchOpen = $('.open-search');
        var $searchMenu = $('.search-menu');
        var $searchClose = $('.close-search');

        function openSearch() {
            $searchMenu.addClass('active').find('[type="text"]').focus();
            $body.addClass('no-scroll');
        }

        function closeSearch() {
            $searchMenu.removeClass('active');
            $body.removeClass('no-scroll');
        }

        $searchOpen.click(openSearch);
        $searchClose.click(closeSearch);

        return {
            open: openSearch,
            close: closeSearch
        }
}());

/* ========================================================================================================================

    Filter

======================================================================================================================== */
var urlParams = (function (strParam) {
        var objParams = {};
        function init(){
            objParams = {};
            // get url parameters
            var arrURLParams = window.location.search.replace('?', '').split('&');
            // obj placeholder for params
            // convert parameters into an object
            arrURLParams.map(function (val) {
                var arrPair = val.split('=');
                objParams[arrPair[0]] = decodeURIComponent(arrPair[1]);
            });
        }
        init();
        return {
            get: function (strParam) { return objParams[strParam]; },
            pull: init
        }
    }());


    var careerFilters = (function(){
        
        if( $('.careers-main').length ){
            var mixer = mixitup('.careers-main');
        }
        
        var filter = urlParams.get('filter');

        
        if( filter ){
            var id = $('button[data-val="'+filter+'"]').attr('id');
            mixer.filter('.'+id);
            console.log(filter);
            console.log(id);
        }
        
    }());



    var locationFilters = (function(){
        
        if( $('.locations-block').length ){
            var mixer = mixitup('.locations-main');
        }
        
        var filter = urlParams.get('filter');

        
        if( filter ){
            var id = $('button[data-val="'+filter+'"]').attr('id');
            mixer.filter('.'+id);
            console.log(filter);
            console.log(id);
        }
        
    }());


    var blogFilters = (function(){
        
        if( $('.blog-filterable').length ){
            var mixer = mixitup('.blog-filterable');
        }
        
        var filter = urlParams.get('filter');

        
        if( filter ){
            var id = $('button[data-val="'+filter+'"]').attr('id');
            mixer.filter('.'+id);
            console.log(filter);
            console.log(id);
        }


        $('.blog').on('click', '.btn--filter', function () {
            $(".active-filters").addClass('active');

        $('.blog-filter .btn--filter.mixitup-control-active').each(function() {

          $(".active-filters__list").text($(this).text());
          
        });

        });


        // show filters 
        $('.blog').on('click', '.toggle-filters', function () {
            $(".blog-filter").slideToggle();
        });

        // sorting feature
        $('.sort-latest').on('click', '.sort-trigger', function () {
            $(".sort-menu").toggleClass('active');
        });
        
    }());



var footerToggle = (function () {
     $('.toggle-btns').on('click', 'button', function (e) {
        $(this).parent().find('button').removeClass('active');
        $(this).addClass('active');
        $(this).parent().parent().find('.toggle-content').hide();
         var activeTab = $(this).attr('href');
         $("#"+activeTab).fadeIn();
    });


}());



/*  var subNavStick = (function () {
    $subNav = $(".sticky-subnav");

    if (window.scrollY) {
        $subNav.addClass('sticky--scrolled');
    }

    $(window).on('scroll', function () {



        if (window.scrollY) {
            $subNav.addClass('sticky');

        } else if (window.scrollY === 0) {
            $subNav.removeClass('sticky');
        }



    });
}());*/

    /*-----------------------------------------------------------------------------GLOBAL ON LOAD----*/

    var LazyLoading = (function () {
        var instance = new LazyLoad();

        function lazyBGImages() {
            var $bgImages = $('[data-bg]:not(.lazy)');
            if ($bgImages.length) {
                $bgImages.each(function () {
                    $(this).addClass('lazy');
                });
            }
            instance.update();
        }

        function update() {
            lazyBGImages();
        }

        lazyBGImages();

        return {
            update: update
        }
    }());

    var SmoothScroll = (function () {
        var $anchorLinks = $('a[href^="#"]').not('a[href="#"]');

        $('a[href="#"]').click(
            function (e) { e.preventDefault(); return; }
        );

        function goTo(target) {
            if (target === "" || !$(target).length) { return; }
            var scrollPos = typeof target === 'number' ? target : $(target).offset().top;

            if (window.innerWidth >= 720) {
                scrollPos -= $('header').outerHeight();
            } else {
                scrollPos -= $('header').outerHeight() * 2;
            }

            $('html, body').stop().animate({
                'scrollTop': scrollPos - 32
            }, 1200, 'swing', function () {
                if (typeof target === 'string') {

                    if (window.location.hash) {
                        // window.location.hash = target;
                    }
                }
            });
        }

        if (window.location.hash) {
            setTimeout(function () {
                goTo(window.location.hash);
            }, 500);
        }

        if ($anchorLinks.length) {
            $anchorLinks.on('click', function (e) {
                if (!$("#" + this.hash.replace('#', '')).length) { return; }
                e.preventDefault();
                goTo(this.hash);
            });
        }

        return { to: goTo }
    }());

    //Global function to toggle simple accordions
    var Accordions = (function () {
        var $accordions = $('.accordion');
        if (!$accordions.length) { return; }

        $accordions.each(function () {
            if ($(this).hasClass('active')) {
                $(this).find('.accordion__content').show();
            }
        });

        $accordions.find('.accordion__trigger').click(function (e) {
            var $this = $(this);
            var $accordion = $this.parent();
            var $content = $accordion.find('.accordion__content');
            var $siblings = $accordion.siblings();

            if ($accordion.hasClass('active')) {
                $accordion.removeClass('active');
                $content.slideUp('fast');
            } else {
                $accordion.addClass('active');
                $siblings.removeClass('active').find('.accordion__content').slideUp('fast');
                $content.slideDown('fast');
            }
        })

    }());

    var Forms = (function () {
        var InputMasks = (function () {
            var $masks = $('[data-mask]');
            if (!$masks.length) { return; }

            /**
             * Key Codes:
             * 8    - backspace
             * 13   - enter
             * 16   - shift
             * 18   - alt
             * 20   - caps
             * 27   - esc
             * 37   - left arrow
             * 38   - up arrow
             * 39   - right arrow
             * 40   - down arrow
             * 46   - delete
             **/
            var exclude_keys = [8, 13, 16, 18, 20, 27, 37, 38, 39, 40, 46];

            $('[data-mask]').keyup(function (e) {
                console.log(e.keyCode);
                if (exclude_keys.indexOf(e.keyCode) > -1) { return; }

                switch (this.dataset.mask) {
                    case 'digits':
                        var x = this.value.replace(/\D/g, '');
                        this.value = x;
                        break;
                    case 'phone':
                        var x = this.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                        console.log(x);
                        this.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                        break;
                    case 'ssn': {
                        var x = this.value.replace(/\D/g, '').match(/^(\d{0,3})(\d{0,2})(\d{0,4})/);
                        this.value = !x[2] ? x[1] : x[1] + '-' + x[2] + '-' + x[3];
                    }
                }
            });
        }());

        //Plugin used for form validation
        var parselyOptions = {
            classHandler: function (parsleyField) {
                var $element = parsleyField.$element;
                if ($element.parent().hasClass('select-menu')) {
                    return $element.parent();
                }
                return $element;
            },
            errorsContainer: function (parsleyField) {
                var $element = parsleyField.$element;
                var $fieldContainer = $element.closest('.form-field');
                if ($fieldContainer) {
                    return $fieldContainer;
                }
            }
        };

        //Global function to set form state classes
        var formStates = (function () {
            $formInputs = $('form :input');
            if (!$formInputs.length) { return; }

            $formSelectMenus = $('.select-menu select, .ginput_container_select select');

            function isGFormInput($el) {
                return $el.parent().hasClass('ginput_container') ? $el.parent().parent() : $el;
            }

            function setFilled($input) {
                $input.addClass('filled');
            }

            function removeFilled($input) {
                $input.removeClass('filled');
            }

            function setFocused() {
                $(this).addClass('focused');
            }

            function removeFocused() {
                $(this).removeClass('focused');
            }

            function checkInput(e) {
                if (this.type == 'button' ||
                    this.type == 'range' ||
                    this.type == 'submit' ||
                    this.type == 'radio' ||
                    this.type == 'checkbox' ||
                    this.type == 'reset') { return; }

                var $this = $(this);
                var $parent = $this.parent();
                var is_selectMenu = $parent.hasClass('select-menu') || $parent.hasClass('ginput_container_select');

                var $input = is_selectMenu ? $parent : $this;

                switch (this.type) {
                    case 'select-one':
                    case 'select-multiple':
                        if (this.value !== '') {
                            setFilled($input);
                        } else {
                            removeFilled($input);
                        }
                        break;
                    default:
                        if (this.value !== '') {
                            setFilled($input);
                        } else {
                            removeFilled($input);
                        }
                        break;
                }
            }

            $formInputs.each(checkInput);
            $formInputs.on('change', checkInput);
            $formInputs.on('focus', setFocused);
            $formInputs.on('blur', removeFocused);
            $formSelectMenus.on('focus', setFocused);
            $formSelectMenus.on('blur', removeFocused);

        }());
        return { options: parselyOptions }
    }());

    //Global function top open / close lightboxes
    var PDMLightbox = (function () {
        //Lightbox reset - This lightbox is empty and present on all pages
        var $lightbox = $('.pdm-lightbox--reset');

        //it's content can be filled from various sources
        //after close, the content is wiped
        var $lightbox_content = $('.pdm-lightbox--reset .pdm-lightbox__content');

        $('body').on('click', '[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target],.lightbox-trigger', function (e) {

            e.preventDefault();

            var iframe = $(this).data('lightbox-iframe');

            if (iframe) {
                var youtubePattern = /(?:http?s?:\/\/)?(?:www\.)?youtu(be\.com\/|\.be\/)(embed\/(.+)(\?.+)?|watch\?v=(.+)(\&.+)?)/g;
                var vimeoPattern = /(?:http?s?:\/\/)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/g;

                if (youtubePattern.test(iframe)) {
                    classes += ' youtube-vid'

                    replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//www.youtube.com/embed/$3?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';

                    iframe = iframe.replace(youtubePattern, replacement);

                }

                if (vimeoPattern.test(iframe)) {

                    classes += ' vimeo-vid'

                    replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//player.vimeo.com/video/$3?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';

                    iframe = iframe.replace(vimeoPattern, replacement);

                }

                $lightbox_content.html('<div class="video-embed">' + iframe + '</div>');
            } else {
                if ($(this).data('lightbox-content')) {
                    var content = $(this).data('lightbox-content');
                } else if ($(this).data('lightbox-target')) {
                    var target = $(this).data('lightbox-target');
                    var content = $('#' + target).html();
                } else {
                    var content = $(this).next('.lightbox-content').html();
                }
                $lightbox_content.html(content);
            }

            var classes = $(this).data('lightbox-classes');
            $lightbox.addClass('active').addClass(classes);

        });

        function closeModal($lightbox) {
            $lightbox.removeClass('active');
            $('body').removeClass('noScroll');
            //wait before removing classes till lightbox closses
            if ($lightbox.hasClass('pdm-lightbox--reset')) {
                setTimeout(function () {
                    $lightbox.find('.pdm-lightbox__content').empty();
                    $lightbox.attr('class', 'pdm-lightbox pdm-lightbox--reset');
                }, 750);
            }
        }

        function openModal($lightbox) {
            $lightbox.addClass('active');
            $('body').addClass('noScroll');
        }

        function updateModal($lightbox, $content) {
            $lightbox.find('.pdm-lightbox__content').html($content);
        }

        $('.pdm-lightbox').on('click', function (e) {
            if (e.target == this) {
                closeModal($(this));
            }
        });

        $('.pdm-lightbox__close').click(function (e) {
            e.stopPropagation();
            closeModal($(this).closest('.pdm-lightbox'));
        });
        return {
            close: closeModal,
            open: openModal,
            update: updateModal
        };
    }());

    //******************************************************Everything under this is optional, feel free to delete


/* ========================================================================================================================

Header

======================================================================================================================== */


  var customMenu = (function () {
        var $body = $('body');
        var $header = $('header.gheader');
        var $adminBar = $('#wpadminbar');
        var $nav = $header.find('.custom-wrap');
        var $headerBtn = $header.find('.btn--gold');

        var header_height = $header.innerHeight();
        if ($adminBar.length) { header_height += $adminBar.innerHeight(); }
        if (window.innerWidth < 960) { $nav.css({ marginTop: header_height }); }

        if (window.innerWidth > 960) { $nav.css({ paddingTop: header_height }); }

        var BurgerMenu = (function () {
            var $burgerMenu = $header.find('.menu-burger');
            var $text = $burgerMenu.find('.menu-burger__text');

            function activate() {
                $burgerMenu.addClass('active').attr('title', 'Close');
                $text.text('Close');
                $nav.addClass('active');
                $body.addClass('no-scroll');
                $headerBtn.addClass('active');

                var styles = { position: 'fixed' };
                if ($adminBar.length) { styles.top = $adminBar.innerHeight(); }

                $header.css(styles);
                $body.css({ marginTop: $header.innerHeight() });
            }

            function reset() {
                $burgerMenu.removeClass('active').attr('title', 'Menu');
                $text.text('Menu');
                $nav.removeClass('active').find('.active').removeClass('active');
                $body.removeClass('no-scroll');
                $headerBtn.removeClass('active');

                var styles = { position: 'sticky' };
                if ($adminBar.length) { styles.top = $adminBar.innerHeight() };

                $header.css(styles);
                $body.css({ marginTop: 0 });
            }

            $burgerMenu.click(function () {
                var $this = $(this);

                if ($this.hasClass('active')) { reset(); } else { activate(); }
            });

            return {
                close: reset,
                open: activate
            }
        }());



        var DropdownMenus = (function () {
            var $menus = $('.menu');
            var $dropmenus = $menus.find('.menu-item__dropdown');
            var $mobileArrow = $dropmenus.find('.mobile-arrow');

            function toggleDropdown(e) {
                e.preventDefault();

                var $this = $(this);
                var $menuItem = $this.parent();

                if ($menuItem.hasClass('active')) {
                    $menuItem.removeClass('active');
                } else {
                    $menuItem.addClass('active');
                }
            }

            $mobileArrow.click(toggleDropdown);
        }());

        var StickyHeader = (function () {
            if (!$header.hasClass('sticky')) { return; }

            if (window.scrollY) {
                $header.addClass('sticky--scrolled');
            }

            $(window).on('scroll', function () {

                if (window.scrollY) {
                    $header.addClass('sticky--scrolled');

                } else if (window.scrollY === 0) {
                    $header.removeClass('sticky--scrolled');
                }

                if ($adminBar.length) {
                    $header.css({ top: $adminBar.innerHeight() });
                }

            });
        }());


        var customMenuHover = (function () {
            // Add class on mouseenter
              $(".custom-menu li").mouseenter(function() {
                  $(".custom-menu li").removeClass("active");
                  $(this).addClass("active");
                  $(".nav-map").empty();
                  var activeContent = $(this).find('a').attr("data-nav-content");
                  $(".nav-column").hide();
                  $(activeContent).show();

                   var bgColor = $(this).find('a').attr("data-bg-color");
                   console.log(bgColor);

                   $('.custom-wrap').css('background-color', bgColor);

              });
        }());


        window.addEventListener('resize', function () {
            $header.css({ position: 'sticky' });
            BurgerMenu.close();

            var styles = { marginTop: window.innerWidth < 960 ? header_height : 0 };

            $nav.css(styles);
        });

    }());


/* var Header = (function () {
        var $body = $('body');
        var $header = $('header.gheader');
        var $nav = $header.find('nav.global');
        var $adminBar = $('#wpadminbar');

        var header_height = $header.innerHeight();
        if ($adminBar.length) { header_height += $adminBar.innerHeight(); }
        if (window.innerWidth < 960) { $nav.css({ marginTop: header_height }); }

        var BurgerMenu = (function () {
            var $burgerMenu = $header.find('.menu-burger');
            var $text = $burgerMenu.find('.menu-burger__text');

            function activate() {
                $burgerMenu.addClass('active').attr('title', 'Close');
                $text.text('Close');
                $nav.addClass('active');
                $body.addClass('no-scroll');

                var styles = { position: 'fixed' };
                if ($adminBar.length) { styles.top = $adminBar.innerHeight(); }

                $header.css(styles);
                $body.css({ marginTop: $header.innerHeight() });
            }

            function reset() {
                $burgerMenu.removeClass('active').attr('title', 'Menu');
                $text.text('Menu');
                $nav.removeClass('active').find('.active').removeClass('active');
                $body.removeClass('no-scroll');

                var styles = { position: 'sticky' };
                if ($adminBar.length) { styles.top = $adminBar.innerHeight() };

                $header.css(styles);
                $body.css({ marginTop: 0 });
            }

            $burgerMenu.click(function () {
                var $this = $(this);

                if ($this.hasClass('active')) { reset(); } else { activate(); }
            });

            return {
                close: reset,
                open: activate
            }
        }());


        window.addEventListener('resize', function () {
            $header.css({ position: 'sticky' });
            BurgerMenu.close();

            var styles = { marginTop: window.innerWidth < 960 ? header_height : 0 };

            $nav.css(styles);
        });

    }());
*/

/* ========================================================================================================================

Load More

======================================================================================================================== */
    var LoadMore = (function () {
        var $loadmore = $('#loadmore');
        if (!$loadmore.length) { return; }

        var $loadmore_text = $loadmore.text();

        $loadmore.click(function () {
            var $this = $(this);
            var $postlist = $this.siblings('.blog-posts');
            var query = WP.query;
            var page = WP.current_page;
            var max = WP.max_page;

            var data = {
                action: 'load_more_posts',
                query: query,
                page: page
            };

            $.ajax({
                url: ajaxURL,
                type: 'post',
                data: data,
                beforeSend: function () {
                    $loadmore.attr('disabled', true).text('Loading Posts');
                },
                error: function (res) {
                    res = JSON.parse(res);
                    console.log(res);
                },
                success: function (posts) {
                    if (posts) {
                        page = WP.current_page++;
                        $loadmore.attr('disabled', false).text($loadmore_text);
                        $postlist.append(posts);
                        LazyLoading.update();

                        if (WP.current_page >= max) { $loadmore.remove(); }
                    } else {
                        $loadmore.remove();
                    }
                }
            });
        });
    }());


/* ========================================================================================================================

Flickity Sliders

======================================================================================================================== */

/*
var testimonialsSlider = (function () {
    $sliders = $('.testimonials-slider');
    if (!$sliders.length) { return };
    $sliders.each(function () {
        var $slider = $(this);
        $slider.flickity({
            prevNextButtons: false,
            contain: true,
            pageDots: true,
            groupCells: true,
            groupCells: 1,
            freeScroll: true,
            draggable: true,
            wrapAround: true,
            cellAlign: 'left',
        });

         // Flickity instance
        var flkty = $slider.data('flickity');


        // Default state
      if ( matchMedia('screen and (max-width: 480px)').matches ) {

        $slider.flickity({
            groupCells: false,
            groupCells: 1
        });

      }

    
    });
}());*/



/*var serviceSlider = (function () {
    $sliders = $('.services-slider');
    if (!$sliders.length) { return };
    $sliders.each(function () {
        var $slider = $(this);
        $slider.flickity({
            prevNextButtons: false,
            contain: true,
            pageDots: false,
            freeScroll: true,
            draggable: true,
            wrapAround: false,
            cellAlign: 'left',
        });

         // Flickity instance
        var flkty = $slider.data('flickity');

         // elements
        var $cellButtonGroup = $('.service-dots');
        var $cellButtons = $cellButtonGroup.find('.dot');

        // update selected cellButtons
            $slider.on('select.flickity', function () {
                $cellButtons.filter('.is-selected')
                    .removeClass('is-selected');
                $cellButtons.eq(flkty.selectedIndex)
                    .addClass('is-selected');
            });        

        // select cell on button click
        $cellButtonGroup.on('click', '.dot', function () {
            var index = $(this).index();
            $slider.flickity('select', index);
        });

    
    });
}());*/

});